import SignUpService from '@/api/SingupService';
import { app } from '@/main';

export const loadCategoriesStore = async () => {
  const signUpservice = new SignUpService();

  const categoriesStore =
    app.$store.getters['businessOnboarding/getCategories'];

  if (categoriesStore && categoriesStore.length > 0) return;

  const {
    status,
    data: { categories }
  } = await signUpservice.getCategories({ version: 2 });

  if (status !== 200) return;

  const transformedCategories = categories.map((category: any) => ({
    value: category.id,
    label: category.name
  }));

  app.$store.dispatch(
    'businessOnboarding/SET_CATEGORIES',
    transformedCategories
  );
};
